var _effectorFileName = "/builds/gmini/front-common/src/metrika/utils.ts";
import ym from 'react-yandex-metrika';
import { yandexMetrikaDisabled } from "./env";
export function createGoal(id) {
  return function () {
    // TODO: remove env variable from library
    if (yandexMetrikaDisabled) {
      return;
    }

    return ym('reachGoal', id);
  };
}